import { render, staticRenderFns } from "./sort-paginate.vue?vue&type=template&id=4bb1d14a"
import script from "./sort-paginate.vue?vue&type=script&lang=js"
export * from "./sort-paginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchSort: require('/usr/src/app/components/search/sort.vue').default})
